"use client";
import React, { useState } from "react";
import styles from "./Footer.module.css";
import Link from "next/link";

const Footer = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <footer className={styles.footer}>
      <div className={styles.contentWrapper}>

        <div className={styles.textSection}>
          <h1 className={styles.heading}>
            Goat Spins – The Ultimate Crypto Gaming Experience
          </h1>
          <p className={styles.paragraph}>
            At Goat Spins, we&apos;re all about giving you a fair deal and an adrenaline-packed ride from your very first spin. Our herd believes in lightning-fast payouts, rock-solid trust, and straight-up honesty. No hidden traps, no endless fine print – just pure gaming freedom. But hey, don&apos;t take our word for it. Try Goat Spins and see why crypto players who chase the best no deposit bonuses always come back for more.
          </p>

          {/* SEO-friendly hidden content */}
          <div
            className={`${styles.moreContent} ${
              showMore ? styles.show : styles.hide
            }`}
          >
            <h2 className={styles.subHeading}>
              Tired of &quot;Bonuses&quot; That Disappear Like Smoke?
            </h2>
            <p className={styles.paragraph}>
              We get it. You&apos;ve seen enough fake promises and &quot;offers&quot; that
              vanish faster than a jackpot on autoplay. At Goat Spins, we don&apos;t bait
              you with empty codes – we give you real no deposit bonuses you can actually
              cash out. No gimmicks, no goat tricks. Just blazing-fast withdrawals, secure
              crypto transactions, and the thrill of winning big without spending a cent.
            </p>

            <p className={styles.ctaText}>
              If you&apos;re serious about finding casinos that actually deliver, explore
              our hand-picked casino bonus guide –{" "}
              <a
                href="https://best-review-casino.com"
                className={styles.ctaLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                your shortcut to the best deals, verified offers, and brutally honest reviews.
              </a>
            </p>
          </div>

          <button
            className={styles.viewMoreBtn}
            onClick={() => setShowMore(!showMore)}
          >
            {showMore ? "View Less" : "View More"}
          </button>
        </div>

        <div className={styles.bottomSection}>
          <div className={styles.copyright}>
            <div className={styles.eighteenPlusIcon}>18+</div>
            <p className={styles.copyrightText}>
              Copyright © <span>{new Date().getFullYear()}</span>.<br />
              All rights reserved.
            </p>
          </div>

          <div className={styles.serviceLogos}>
            <img
              src="/new-site/cds_d_mode.svg"
              alt="CDS Logo"
              className={styles.serviceLogo}
            />
            <img
              src="/new-site/rtg-logo_d_mode.svg"
              alt="Spin Logic Gaming Logo"
              className={styles.serviceLogo}
            />
            <Link href="https://chipy.com/news/goat-spins-casino-editor-s-choice-march-2026">
            <img
              src="/new-site/chipy logo goat spins.png"
              alt="Chipy Logo"
              className={styles.serviceLogoChipy}
            /></Link>
            <Link href="https://www.casino-crush.com/casinodb/goat-spins-casino-review-2045.html">
            <img
              src="/new-site/casino-crush.png"
              alt="Casino Crush Logo"
              className={styles.serviceCrushChipy}
            /></Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;